"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = Tab;
exports["default"] = Tabs;
var _react = _interopRequireWildcard(require("react"));
var _tabsModule = _interopRequireDefault(require("./tabs.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function Tabs(_ref) {
  var children = _ref.children,
    _ref$contentClassName = _ref.contentClassName,
    contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
    _ref$tabsClassName = _ref.tabsClassName,
    tabsClassName = _ref$tabsClassName === void 0 ? '' : _ref$tabsClassName;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var tabs = Array.isArray(children) ? children : [children];
  var tabRefs = tabs.map(function () {
    return (0, _react.useRef)();
  });
  var id = (0, _react.useId)();
  if (!children) return null;
  var focusOnTab = function focusOnTab(index) {
    tabRefs[index].current.focus();
    setSelected(index);
  };
  var buildId = function buildId(index) {
    return "tab-".concat(id, "-").concat(index);
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'ArrowLeft') {
      focusOnTab(Math.min(selected, 0));
    } else if (event.key === 'ArrowRight') {
      focusOnTab(Math.min(selected + 1, tabs.length - 1));
    }
  };
  var renderTabHeader = function renderTabHeader(tab, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      role: "tab",
      "aria-selected": selected === index,
      "aria-controls": buildId(index),
      tabIndex: selected === index ? 0 : -1,
      className: _tabsModule["default"].tab,
      disabled: tab.props.disabled,
      onClick: function onClick() {
        return focusOnTab(index);
      },
      onKeyDown: handleKeyDown,
      ref: tabRefs[index],
      "data-event": "tabClick",
      "data-text": tab.props.label,
      "data-position": index + 1,
      "data-items": tabs.length,
      children: tab.props.label
    }, index);
  };
  var renderTabContent = function renderTabContent(tab, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
      id: buildId(index),
      className: _tabsModule["default"].tabContent,
      "aria-expanded": selected === index,
      hidden: selected !== index,
      "aria-label": tab.props.label,
      role: "tabpanel",
      tabIndex: 0,
      children: tab
    }, index);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "tablist",
      className: (0, _classnames["default"])(_tabsModule["default"].tabs, tabsClassName),
      children: tabs.map(renderTabHeader)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classnames["default"])(_tabsModule["default"].tabContentContainer, contentClassName),
      children: tabs.map(renderTabContent)
    })]
  });
}
function Tab(_ref2) {
  var children = _ref2.children;
  return children;
}